var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center w-100"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-bar-fill",style:({
        width: `${(_vm.value / _vm.total || 1) * 100}%`,
      })})]),_c('div',{staticClass:"progress-label"},[_vm._v(" "+_vm._s(_vm.value)+"/"+_vm._s(_vm.total)+" "+_vm._s(_vm.unit)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }